import { Button } from '@amzn/awsui-components-core';
import { CodeLink, RepoType } from '@amzn/awscat-pattern-library-service-model';
import React, { useEffect, useState } from 'react';
import CodeRepoModal from './CodeRepoModal';
import { CodeRepoFormCtx, CodeRepoFormCtxData } from './form/CodeRepoFormContext';
import { CodeRepoFormData } from './form/CodeRepoFormData';

interface Props {
  repoData: CodeLink;
  addRepoToContent: (repoData: CodeLink) => void;
  allowedRepoType: RepoType;
}

const EditCodeRepoModalButton = (props: Props) => {
  const [repoData, setRepoData] = useState<CodeRepoFormData>({
    url: props.repoData.url,
    title: props.repoData.label,
    branch: props.repoData.branch,
    repoType: props.allowedRepoType,
    securityReviewUrl: props.repoData.appsecTicket,
    securityReviewStatus: props.repoData.appsecStatus,
    securityGuardian: props.repoData.appsecGuardian,
    openSourceReviewUrl: props.repoData.openSourceTicket,
    openSourceReviewStatus: props.repoData.openSourceStatus,
  });
  const [invalidFormFields, setInvalidFormFields] = useState(new Set<string>());
  const [showValidationErrors, setShowValidationErrors] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    setRepoData({
      url: props.repoData.url,
      title: props.repoData.label,
      branch: props.repoData.branch,
      repoType: props.allowedRepoType,
      securityReviewUrl: props.repoData.appsecTicket,
      securityReviewStatus: props.repoData.appsecStatus,
      securityGuardian: props.repoData.appsecGuardian,
      openSourceReviewUrl: props.repoData.openSourceTicket,
      openSourceReviewStatus: props.repoData.openSourceStatus,
    });
  }, [props.repoData, props.allowedRepoType]);
  const showModal = () => setIsModalVisible(true);
  const hideModal = () => {
    setIsModalVisible(false);
    setInvalidFormFields(new Set<string>());
    setShowValidationErrors(false);
  };

  const handleInputValidation = (fieldId: string, invalid: boolean) => {
    if (invalid) {
      invalidFormFields.add(fieldId);
    } else {
      invalidFormFields.delete(fieldId);
    }
    setInvalidFormFields(invalidFormFields);
  };

  const contextData: CodeRepoFormCtxData = {
    repoData,
    setRepoData,
    addRepoToContent: props.addRepoToContent,
    invalidFormFields,
    onInputValidation: handleInputValidation,
    showValidationErrors,
    setShowValidationErrors,
  };

  return (
    <CodeRepoFormCtx.Provider value={contextData}>
      <Button onClick={showModal} iconName="edit" variant="icon" ariaLabel="Edit code repository" />
      <CodeRepoModal visible={isModalVisible} onDismiss={hideModal} />
    </CodeRepoFormCtx.Provider>
  );
};

export default EditCodeRepoModalButton;
